import { catchError } from "../../utils/errorUtil";
import { isBrowserChrome } from "../common/global";

const props = {
    //MARKERS
    warrantyRegFormMarker: '#m-warranty-reg-form',
    contactUsFormMarker: '#m-contact-us-form',
    becomeDealerMarker: '#m-become-dealer-form',

    //WARRANTY FORM
    warrantyDealershipSelected: '#DealershipPurchasedFromId',
    warrantyDealershipSelectedOther: '#DealershipPurchasedFromOtherInfo',

    //CONTACT US
    locationMap: '#location-map'
};

//for Contact Us location map
var map = null;
var infoWindow = null;
var locationMarker, i = null;
var geocoder = null;


export function initSiteForms() {

    if ($(props.warrantyRegFormMarker).length) {

        initWarrantyRegPageEvents();
    }

    if ($(props.contactUsFormMarker).length) {

        initContactUsPageEvents();
    }

    if ($(props.becomeDealerMarker).length) {

        initBecomeDealerPageEvents();
    }
}

async function initWarrantyRegPageEvents() {

    $(props.warrantyDealershipSelected).off('change').on('change', function (e) {

        if ($(this).val() == "0") {

            //other selected. display banner for Other options
            $(props.warrantyDealershipSelectedOther).show(500);
        } else {

            $(props.warrantyDealershipSelectedOther).hide(500);
        }

    });

    //loquate initialisation
    var addressFields = [
        { element: "address-search", field: "" },
        { element: "Address1", field: "Line1" },
        { element: "Address2", field: "Line2", mode: pca.fieldMode.POPULATE },
        { element: "Address3", field: "City", mode: pca.fieldMode.POPULATE },
        { element: "City", field: "Province", mode: pca.fieldMode.POPULATE },
        { element: "Postcode", field: "PostalCode" }
    ];

    var addressOptions = { key: "ZC65-ZN49-DG59-RE95", countries: { codesList: "GBR" }, setCountryByIP: false };

    var control = new pca.Address(addressFields, addressOptions);

    //prevents chrome ac getting in the way
    if (isBrowserChrome() === true) {

        for (i = 0; control.fields.length > i; i++) {

            $('#' + control.fields[i].element).prop('autocomplete', 'PCATEST');

        };
    };
}

async function initBecomeDealerPageEvents() {

    //loquate initialisation
    var addressFields = [
        { element: "address-search", field: "" },
        { element: "Address1", field: "Line1" },
        { element: "Address2", field: "Line2", mode: pca.fieldMode.POPULATE },
        { element: "Address3", field: "City", mode: pca.fieldMode.POPULATE },
        { element: "City", field: "Province", mode: pca.fieldMode.POPULATE },
        { element: "Postcode", field: "PostalCode" }
    ];

    var addressOptions = { key: "ZC65-ZN49-DG59-RE95", countries: { codesList: "GBR" }, setCountryByIP: false };

    var control = new pca.Address(addressFields, addressOptions);

    //prevents chrome ac getting in the way
    if (isBrowserChrome() === true) {

        for (i = 0; control.fields.length > i; i++) {

            $('#' + control.fields[i].element).prop('autocomplete', 'PCATEST');

        };
    };
}


async function initContactUsPageEvents() {

    initialiseLocationMap();
}


async function initialiseLocationMap() {

    var allowedBounds = new google.maps.LatLngBounds();

    geocoder = new google.maps.Geocoder();
    var latlng = new google.maps.LatLng(51.8347123, 0.1500933);
    var mapOptions = {
        mapTypeControl: false,
        fullscreenControl: false,
        zoom: 10,
        //mapTypeId: google.maps.MapTypeId.ROADMAP,
        region: 'uk'//,
        //styles: [{ "featureType": "all", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "all", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#000000" }, { "lightness": "35" }, { "gamma": "1" }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "off" }, { "color": "#000000" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "administrative.locality", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "administrative.locality", "elementType": "geometry.fill", "stylers": [{ "lightness": "-11" }] }, { "featureType": "administrative.locality", "elementType": "labels.text", "stylers": [{ "color": "#fc5d1e" }] }, { "featureType": "administrative.land_parcel", "elementType": "all", "stylers": [{ "visibility": "on" }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 20 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.park", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "poi.park", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "poi.park", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "road", "elementType": "all", "stylers": [{ "visibility": "simplified" }] }, { "featureType": "road", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#475058" }, { "lightness": "-48" }, { "saturation": "-73" }, { "weight": "3.98" }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#000000" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 18 }] }, { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{ "lightness": "7" }] }, { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "lightness": "63" }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 16 }, { "visibility": "off" }] }, { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "lightness": "-8" }, { "gamma": "1.73" }] }, { "featureType": "road.local", "elementType": "geometry.stroke", "stylers": [{ "lightness": "-1" }] }, { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "lightness": "24" }] }, { "featureType": "transit", "elementType": "all", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#000000" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#475058" }, { "lightness": 17 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#d1e0e9" }, { "lightness": "-70" }, { "saturation": "-75" }] }, { "featureType": "water", "elementType": "geometry.stroke", "stylers": [{ "visibility": "off" }] }, { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "lightness": "-54" }, { "hue": "#ff0000" }] }]
    };
    map = new google.maps.Map(document.getElementById("location-map"),
        mapOptions);

    // ***** Markers *****
    infoWindow = new google.maps.InfoWindow();

    google.maps.event.addListenerOnce(map, 'idle', function () {

        // do something only the first time the map is loaded
        geocoder.geocode({
            'address': 'hayter mowers cm23 4bu'
        }, async function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {

                if (locationMarker) locationMarker.setMap(null);

                allowedBounds = new google.maps.LatLngBounds();

                var markerIcon = {
                    url: "/images/core/dealerships/finder.png",
                    scaledSize: new google.maps.Size(26, 35)
                };

                locationMarker = new google.maps.Marker({
                    map: map,
                    title: 'Hayter Mowers',
                    position: results[0].geometry.location,
                    icon: markerIcon
                });

                var customLat = results[0].geometry.location.lat();
                var customLng = results[0].geometry.location.lng();

                allowedBounds.extend(new google.maps.LatLng(customLat, customLng));

                map.fitBounds(allowedBounds);

                map.setZoom(15);
                map.panTo(results[0].geometry.location)

                // Build info Window
                var iwContent = '<div id="content">' +
                    '<div class="text-size-rem-10 font-weight-bold">Hayter Mowers</div>' +
                    '<p><strong>Phone: </strong><a href="tel:01279723444">01279 723444</a></p>' +
                    '</div>';


                google.maps.event.addListener(locationMarker, 'click', (function (locationMarker, i) {
                    return function () {
                        infoWindow.setContent(iwContent);
                        infoWindow.open(map, locationMarker);
                    }
                })
                    (locationMarker, i));


            } else {
                alert('Geocode was not successful for the following reason: ' + status);
            }

        });
    });

}
